// Proactive Alert Thresholds Panel — v119.69 (extracted from WhatsAppPanel.jsx)
// Tunes the background WhatsApp scheduler that pushes alerts to every
// admin phone when complaints/urgent messages cross the threshold in 24h.
import React, { useCallback, useEffect, useState } from "react";
import { api } from "../lib/api";
import { toast } from "sonner";

const lblStyle = { display: "block", fontSize: 11.5, color: "var(--muted)", marginBottom: 4, fontWeight: 600 };

export default function AlertThresholdsPanel() {
  const [s, setS] = useState(null);
  const [saving, setSaving] = useState(false);
  const [testing, setTesting] = useState(false);

  const load = useCallback(async () => {
    try {
      const r = await api.get("/whatsapp/alert-thresholds");
      setS(r.data || {});
    } catch (_e) { setS({}); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!s) return <div className="card" style={{ padding: 20, textAlign: "center" }}>⏳ جارٍ التحميل...</div>;

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/whatsapp/alert-thresholds", s);
      toast.success("تم الحفظ");
    } catch (e) { toast.error(e?.response?.data?.detail || "فشل الحفظ"); }
    finally { setSaving(false); }
  };
  const runTest = async () => {
    setTesting(true);
    try {
      await api.post("/whatsapp/alert-thresholds/test");
      toast.success("تم تشغيل الفحص — راجع واتساب");
    } catch (e) { toast.error(e?.response?.data?.detail || "فشل الفحص"); }
    finally { setTesting(false); }
  };
  const set = (k, v) => setS((p) => ({ ...p, [k]: v }));

  return (
    <div className="card" style={{ padding: 14 }} data-testid="wa-alerts-panel">
      <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8, color: "var(--brown-deep)" }}>
        🚨 التنبيهات الاستباقية على واتساب
      </div>
      <p style={{ fontSize: 11.5, color: "var(--muted)", marginBottom: 14, lineHeight: 1.7 }}>
        كل 10 دقائق نفحص الرسائل المُصنّفة من العملاء. لو وصل عدد الشكاوى أو الرسائل العاجلة
        للحد المحدد خلال 24 ساعة، تُرسل تنبيهات تلقائية لكل أرقام المدراء.
        ميزة «فترة التهدئة» تمنع تكرار التنبيه عن نفس الموضوع.
      </p>
      <div style={{ display: "grid", gap: 12 }}>
        <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <input type="checkbox" checked={!!s.enabled}
            onChange={(e) => set("enabled", e.target.checked)}
            data-testid="wa-alerts-enabled" />
          <span style={{ fontSize: 12.5, fontWeight: 700 }}>تفعيل التنبيهات</span>
        </label>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div>
            <label style={lblStyle}>حد الشكاوى (آخر 24 ساعة)</label>
            <input type="number" min="1" max="100" className="sim-input"
              value={s.complaints_24h_threshold ?? 3}
              onChange={(e) => set("complaints_24h_threshold", Number(e.target.value))}
              data-testid="wa-alerts-complaints-th" />
          </div>
          <div>
            <label style={lblStyle}>حد الرسائل العاجلة (24 ساعة)</label>
            <input type="number" min="1" max="100" className="sim-input"
              value={s.urgent_24h_threshold ?? 1}
              onChange={(e) => set("urgent_24h_threshold", Number(e.target.value))}
              data-testid="wa-alerts-urgent-th" />
          </div>
        </div>
        <div>
          <label style={lblStyle}>فترة التهدئة بين التنبيهات (ساعات)</label>
          <input type="number" min="0.5" max="48" step="0.5" className="sim-input"
            value={s.cooldown_hours ?? 4}
            onChange={(e) => set("cooldown_hours", Number(e.target.value))}
            data-testid="wa-alerts-cooldown" />
        </div>
        <div style={{ display: "flex", gap: 8, marginTop: 6 }}>
          <button className="btn" disabled={saving} onClick={save} data-testid="wa-alerts-save">
            {saving ? "جارٍ الحفظ..." : "💾 حفظ الإعدادات"}
          </button>
          <button className="btn btn-soft" disabled={testing} onClick={runTest} data-testid="wa-alerts-test">
            {testing ? "جارٍ الفحص..." : "🚀 تشغيل فحص الآن"}
          </button>
        </div>
      </div>
    </div>
  );
}
